import {Loading, MessageBox, Message} from 'element-ui'
import ax from '@/utils/request'
import upd from '@/utils/upDown'
import store from "@/core/services/store";
import myJwt from '@/utils/myjwt'
import axios from 'axios'
// import { getSign } from '@/utils/sign'
export default {
  /**
   * 指定下个光标
   * @param {Object} thiz
   * @param {Object} key
   * @param {Object} index
   * @param {Object} e
   * 绑定示例: :ref="'num'+scope.$index" @keydown.native="onNextFoces('mini_amount', scope.$index, $event)"
   * 事件：onNextFoces(key, index, e){tom.onNextFoces(this, key, index, e);},
   */
  onNextFoces(thiz, key, index, e) {
    var keyCode = e.keyCode || e.which || e.charCode;
    if(keyCode=== 13) {
      var _ref = key+index;
      if(thiz.$refs[_ref]){
        // console.log(_ref,'thiz.$refs[_ref]')
        thiz.$refs[_ref].focus();
        var _nextClazz = thiz.$refs[_ref].$el.className
        if(_nextClazz.indexOf("select") == -1) {
          thiz.$refs[_ref].select()
        }


      }
      var pClassName = e.srcElement.parentNode.offsetParent.className;
      if(pClassName.indexOf("el-select") != -1) {
        var refId = e.srcElement.getAttribute('id');
        if(refId) {
          thiz.$refs[refId].blur()
        }
      }
    }
  },
  /**
   * 光标事件
   * @param {Object} ev   事件
   */
  onFoces(ev) {
	 ev.target.select();
  },

  /**
   * 消息:弹出提示
   * @param {Object} msg
   * @param {Object} type
   */
  alert(msg, type){
      MessageBox.alert(msg, '提示信息', {
          type:type?type:'',
          callback: () => {

          }
      });
  },
  /**
   * 消息:弹框提示，带确认事件
   * @param {Object} msg
   * @param {Object} type
   * @param {Object} done
   */
  confirm(msg,type,done){
      MessageBox.confirm(msg, '提示信息', {
        type:type
      }).then(() => {
          if(done&&typeof(done)=="function") done()
      }).catch(() => {});
  },
  /**
   * 消息:顶部提示
   * @param {Object} msg
   * @param {Object} type
   */
  message(msg,type){
      Message({type: type?type:'info', message: msg})
  },
  /**
   * 显示遮罩
   * @param {Object} text
   */
  showLoading(text) {
    var _msg = '处理中...';
    if (text) {
      _msg = text;
    }
    Loading.service({
      fullscreen: true,
      text: _msg,
      background: 'rgba(0, 0, 0, 0.5)'
    });
  },
  /**
   * 关闭遮罩
   * @param {Object} text
   */
  closeLoading() {
    setTimeout(function (){
    	Loading.service({}).close();
    }, 500);
  },
  /**
   * 获取URI参数数据
   * @param {Object} data
   */
  getUrlParamsToJson(thiz, data) {
    if (thiz) {
      return this.getDecodeJson(thiz.$route.params.params);
    }
    if (!data) {
      return {};
    }
    return this.getDecodeJson(data);
  },

  /**
   * 地址绑定参数
   * @param {Object} url
   * @param {Object} params
   */
  buildUrlInner(url, params) {
    if (this.isEmptyObject(params)) {
      return url;
    }
    return url + "/" + encodeURI(JSON.stringify(params));
  },
  isEmptyObject(e) {
    var t;
    for (t in e)
      return !1;
    return !0
  },
  
  // 跳转新窗口
  goGoImpl(url, params) {
    // 外部地址
    if (url.indexOf("http") == 0 || url.indexOf("www.") == 0) {
      window.open(url);
      return;
    }
    var _url = this.buildUrlInner(url, params);
    window.open(_url);
  },
  resetFormImpl(thiz, refFrom) {
    if (thiz.$refs[refFrom] != undefined) {
      thiz.$refs[refFrom].resetFields();
    }
  },
  getRequestMethod(method) {
    if(!method) {
      return 'post'
    }
    return method;
  },
  checkRequestObj(obj) {
    if(!obj) {
      return {code:-1,msg:'请求对象不能为空'};
    }
    if(!obj.url) {
      return {code:-2,msg:'请求地址不能为空'};
    }
    return {code:0,msg:'请求对象参数正常'};
  },
  /**
   * 删除
   * @param {Object} obj
   * @param {Object} success
   * @param {Object} error
   */
  doDelete(obj, success, error) {
    var thiz = this;
    var _msg = '';
    if (obj.msg) {
      _msg = '你确定删除, 是否继续?'
    } else {
      _msg = obj.msg;
    }
    thiz.confirm(_msg, 'warning', function() {
      return thiz.request(obj, true, success, error);
    });
  },
  /**
   * 提交表单
   * @param {Object} thiz
   * @param {Object} refFrom
   * @param {Object} obj
   * @param {Object} success
   * @param {Object} error
   */
  doSubmitForm(thiz, refFrom, obj, success, error) {
    var that = this;
    thiz.$refs[refFrom].validate((valid) => {
      if (valid) {
        return that.request(obj, true, success, error);
      } else {
        return false;
      }
    });
  },
  /**
   * 请求
   * @param {Object} obj        参数{url, method, data, msg}
   * @param {Object} isLoding
   * @param {Object} success
   * @param {Object} error
   */
  request(obj, isLoding, success,error) {
    var thiz = this;
    var chk = thiz.checkRequestObj(obj);
    if(chk.code < 0) {
      thiz.alert(chk.msg, "info")
      return;
    }
    if(isLoding) thiz.showLoading();
    // var _data = getSign(obj.data);
    var _data =obj.data;
    var _method = thiz.getRequestMethod(obj.method);
    var _url = obj.url;
    // 方式1：兼容函数回调
    if (success && typeof(success) === "function") {
      ax({ url: _url, method: _method, data: _data }).then(function (res) {
        // console.log(this)
        // if (res.code = 403) {
        //   this.$store.dispatch(LOGOUT).then(() => this.$router.push({ name: "login" }));''
        // }
        if(isLoding) thiz.closeLoading();
        success(res);
        // console.log(res)
      }, function (err) {
        // console.log(err)
        if(isLoding) thiz.closeLoading();
        if (error && typeof(error) === "function") {
          error(err);
        }
      });
    } else {
    // 方式2：直接返回
       return ax({url: _url, method:_method, data: _data}).then(response => {
         if(isLoding) thiz.closeLoading();
         return response;
       }, error => {
         if(isLoding) thiz.closeLoading();
         return error;
       });
    }
  },
  onUpload(src, file, callback) {
    upd.uploadFile('/UploadFile/ClientFiles/'+src,file,callback)
  },

  onUploadFile(url, file, callback) {
    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': "Bearer " + store.getters.token,
      //   'X-TOKEN':jwtCode
      }
    }
    var service =axios.create({
        baseURL:'http://192.168.0.129:33333',
      // baseURL: process.env.VUE_APP_BASE_API,
      timeout: 50000 // request timeout
    })
    console.log(file);
    service.post(url,file,config).then( res => {
        if(res.data.status==200){
            callback(res)
            return;
        }
      }).catch( res => {
          console.log(res)
      })
  }
}
